module.exports = __webpack_public_path__ + "media/mjollnir3.b1dea29e.webm";